class Accordion {
  constructor() {
    this.accordions = Array.from(document.querySelectorAll('.dce-block__accordion'));

    if (this.accordions.length > 0) {
      this.accordions.forEach(accordion => {
        const accordionToggle = accordion.querySelector('.accordion__toggle-button');
        accordionToggle.addEventListener('click', this.handleClick.bind(this));
      });
    }
  }

  handleClick(e) {
    const el = e.target;
    const isOpen = el.getAttribute('aria-expanded');

    isOpen === 'true'
      ? el.setAttribute('aria-expanded', 'false')
      : el.setAttribute('aria-expanded', 'true');
  }
}

export default Accordion;
